
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Divider, Heading, useTheme, VStack } from '@chakra-ui/react';
import { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import ResetPasswordModal from '../components/Modals/ResetPasswordModal';
import HeadModule from '../components/Modules/HeadModule';
import HomeHero from '../components/Modules/HomeHero';
import ServiceList from '../components/Modules/ServiceList';
import SubscriptionsHome from '../components/Modules/SubscriptionsHome';
import { SUPPORTED_MODELS } from '../constants/models';
import { ALL_SKILLS } from '../constants/skills';
import { fetchExamplePosts } from './api/example-posts';
// noinspection JSUnusedGlobalSymbols
const getStaticProps: GetStaticProps = async () => {
    const examplePostsParam = await fetchExamplePosts();
    return {
        props: {
            examplePostsParam,
        },
        revalidate: 900,
    };
};
interface Props {
}
const Index = ({}: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (<VStack spacing={[20, null, 24]} w='full' align='center' mb={[20, null, 24]}>
      <HeadModule title='meta_title_home' description='meta_description_home'/>
      <HomeHero />
      <VStack spacing={7} w='full' align='start'>
        <Heading color={theme.colors.text.basic} variant='large' id='services-list'>
          {t('skill:gen_skills')}
        </Heading>
        <ServiceList serviceGroups={[...ALL_SKILLS, SUPPORTED_MODELS]}/>
      </VStack>
      <Divider variant='separator2' w={64}/>
      <SubscriptionsHome />

      <ResetPasswordModal />
    </VStack>);
};
// noinspection JSUnusedGlobalSymbols
export default Index;

    async function __Next_Translate__getStaticProps__19bb2fd5afd__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19bb2fd5afd__ as getStaticProps }
  